export default {
    "edit-external-entity": "تعديل جهة خارجية",
    "add-new-entity": "إضافة جهة خارجية",
    "addresses": "العناوين",
    "this-entity-data": "هذه الجهة",
    "new-entity-external": "جهة جديدة",
    "customersTab": {
        doctor: "الأطباء",
        pharmacy: "الصيدليات",
        center: "المراكز"
    }
}